import { useState } from "react";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessFileCont from "../ProcessFile/ProcessFileCont";

import { getLabel } from "../../tools/Dictionary";

const ProcessDesignerFileModal = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  //const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const OnSelectFile = props.OnSelectFile;

  //State
  const [loading, setLoading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });






  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "1200px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesignerModal", "Select file")}
        </div>
        <div className="page_modal_body_cont">
          <ProcessFileCont
            IsDesktop={IsDesktop} 
            ParentLoading={loading} 
            setParentLoading={setLoading} 
            Access={Access}
            Selectable={true}
            OnSelect={OnSelectFile}
          />
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerFileModal